import { useContext, useEffect, useState } from 'react'
import {
  createSearchParams,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { getRequest } from '../../../../../services/base'
import ItemLink from '../../../../common/ItemLink'
import { NavContext } from '../../../../../context/global_context'

const SearchConnectorSection = () => {
  let { vehicle } = useParams()

  const [searchValue, setSearchValue] = useState()
  const [connectors, setConnectors] = useState([])
  const [searchParams, setSearchParams] = useSearchParams()
  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    if (searchParams.has('q')) {
      getConnectors(searchParams.get('q'))
    }
  }, [])

  const getConnectors = async (searchValue) => {
    let res = await getRequest(
      `/api/connector/?search=${searchValue}&vehicle=${vehicle}`
    )
    setConnectors(res.results)
  }

  return (
    <div className="flex-1 w-1/3 flex flex-col p-4 bg-tracer-dark-blue flex-grow">
      <div className="flex flex-col w-full space-y-2">
        <div className="flex space-x-5">
          <div className="w-2/3">
            <input
              className="w-full bg-white h-10 px-2 rounded focus:outline-none"
              name="search_connector"
              placeholder="Search Connectors"
              autoComplete="off"
              type="search"
              onChange={(e) => {
                setSearchValue(e.target.value)
                if (!e.target.value) {
                  setSearchParams({
                    dtc_id: searchParams.getAll('dtc_id'),
                    q: '',
                  })
                  setConnectors([])
                }
              }}
              defaultValue={searchValue}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  setSearchValue(e.target.value)
                  if (!e.target.value) {
                    setSearchParams({
                      dtc_id: searchParams.getAll('dtc_id'),
                      q: '',
                    })
                    setConnectors([])
                  } else {
                    getConnectors(e.target.value ? e.target.value : '')
                    setSearchParams({
                      dtc_id: searchParams.getAll('dtc_id'),
                      q: e.target.value ? e.target.value : '',
                    })
                  }
                }
              }}
            />
          </div>
          <div className="w-1/3">
            <button
              className="btn"
              onClick={(e) => {
                getConnectors(searchValue ? searchValue : '')
                setSearchParams({
                  dtc_id: searchParams.getAll('dtc_id'),
                  q: searchValue ? searchValue : '',
                })
                if (!searchValue) {
                  setConnectors([])
                }
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {connectors?.length > 0 ? (
        <>
          <h2 className="text-white text-center py-4">Select a Connector</h2>
          <div className="overflow-y-auto">
            {connectors.map((connector, index) => {
              return (
                <ItemLink
                  name={connector.name}
                  requestUri={`/vehicles/${vehicle}/dtcs/mappings/${
                    connector.id
                  }/?${createSearchParams({
                    dtc_id: searchParams.getAll('dtc_id'),
                    connector_name: connector.name,
                    q: searchParams.getAll('q'),
                  })}`}
                  description={connector.description}
                  infoLines={[]}
                  key={`connector-item-${index}`}
                />
              )
            })}
          </div>
        </>
      ) : (
        <div className="flex items-center text-white justify-center flex-grow">
          <p className="w-100 text-center">
            Search for Connectors to get started
          </p>
        </div>
      )}
    </div>
  )
}

export default SearchConnectorSection
